import { Autocomplete, TextField } from "@mui/material";

interface FolderNameInputProps {
  value: string;
  onChange: (value: string) => void;
  existingFolders: string[];
  label?: string;
  placeholder?: string;
  autoFocus?: boolean;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
}

/** Free-solo folder picker: any typed value is accepted; empty means "ungrouped". */
export function FolderNameInput({
  value,
  onChange,
  existingFolders,
  label = "Folder",
  placeholder = "Ungrouped",
  autoFocus,
  disabled,
  error,
  helperText,
}: FolderNameInputProps) {
  return (
    <Autocomplete
      freeSolo
      autoHighlight
      options={existingFolders}
      inputValue={value}
      onInputChange={(_event, newValue) => onChange(newValue)}
      disabled={disabled}
      size="small"
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          autoFocus={autoFocus}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
}
